// src/components/shortlist-toggle.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  mutation RemoveShortlistItem($context: ContextInput!, $productId: String!, $productType: ProductType!) {\n    removeShortlistItem(context: $context, productId: $productId, productType: $productType) {\n      result\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  mutation SaveShortlistItem($context: ContextInput!, $productId: String!, $productType: ProductType!, $metadata: [ShortlistMetadataInput!]) {\n    saveShortlistItem(context: $context, productId: $productId, productType: $productType, metadata: $metadata) {\n      id\n      productId\n      productType\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  query LocalShortlistedItems {\n    localShortlistedItems @client {\n      id\n      productType\n      isShortlisted\n      __typename\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
import React2 from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkFavoriteSwitch } from "uitk-react-switch";
// src/__generated__/types.ts
var ProductType = /* @__PURE__ */ function(ProductType3) {
    ProductType3["ARTICLE"] = "ARTICLE";
    ProductType3["CAR_DETAILS"] = "CAR_DETAILS";
    ProductType3["DESTINATION"] = "DESTINATION";
    ProductType3["DESTINATION_EXPERIENCE"] = "DESTINATION_EXPERIENCE";
    ProductType3["EXPERIENCE"] = "EXPERIENCE";
    ProductType3["EXPERT_TIP"] = "EXPERT_TIP";
    ProductType3["FLIGHT_SEARCH"] = "FLIGHT_SEARCH";
    ProductType3["LX_DETAILS"] = "LX_DETAILS";
    ProductType3["NEIGHBORHOOD"] = "NEIGHBORHOOD";
    ProductType3["POI_GAIA"] = "POI_GAIA";
    ProductType3["PROPERTY_DETAILS"] = "PROPERTY_DETAILS";
    return ProductType3;
}(ProductType || {});
// src/components/shortlist-toggle-provider.tsx
import React, { useMemo } from "react";
var defaults = {
    /**
   * foo
   */ dispatchHandler: function() {}
};
var ShortlistToggleContext = React.createContext(defaults);
var ShortlistToggleProvider = function(props) {
    var children = props.children, dispatchHandler = props.dispatchHandler;
    var value = {
        dispatchHandler: dispatchHandler
    };
    return /* @__PURE__ */ React.createElement(ShortlistToggleContext.Provider, {
        value: useMemo(function() {
            return value;
        }, [
            value
        ])
    }, children || null);
};
var useShortlistToggle = function() {
    var dispatchHandler = React.useContext(ShortlistToggleContext).dispatchHandler;
    return {
        toggleDispatch: dispatchHandler
    };
};
// src/components/shortlist-toggle.tsx
var MutationRemoveShortlistItem = gql(_templateObject());
var MutationSaveShortlistItem = gql(_templateObject1());
var LocalStateQuery = gql(_templateObject2());
var optimisticRemoveResponse = function() {
    return {
        removeShortlistItem: {
            __typename: "RemoveItemResults",
            result: "SUCCESS" /* SUCCESS */ 
        }
    };
};
var optimisticSaveResponse = function(productId, productType) {
    return {
        saveShortlistItem: {
            __typename: "SavedItem",
            id: "temp-".concat(productId),
            productId: productId,
            productType: productType
        }
    };
};
var ShortlistToggle = function(props) {
    var _localShortlists_localShortlistedItems, _localShortlists, _localShortlists_localShortlistedItems_find, _localShortlists_localShortlistedItems1, _localShortlists1;
    var onChange = props.onChange, _props_initialChecked = props.initialChecked, initialChecked = _props_initialChecked === void 0 ? false : _props_initialChecked, inputs = props.inputs, label = props.label;
    var context = useBexApi().context;
    var toggleDispatch = useShortlistToggle().toggleDispatch;
    var metadata = inputs.metadata, productId = inputs.productId, productType = inputs.productType;
    var variables = {
        context: context,
        metadata: metadata,
        productId: productId,
        productType: productType
    };
    var _React2_useState = _sliced_to_array(React2.useState("".concat(productId, "-").concat(productType)), 2), id = _React2_useState[0], setId = _React2_useState[1];
    var _useQuery = useQuery(LocalStateQuery), localShortlists = _useQuery.data;
    var hasLocalState = (_localShortlists = localShortlists) === null || _localShortlists === void 0 ? void 0 : (_localShortlists_localShortlistedItems = _localShortlists.localShortlistedItems) === null || _localShortlists_localShortlistedItems === void 0 ? void 0 : _localShortlists_localShortlistedItems.find(function(shortlist) {
        return shortlist.id === productId;
    });
    var isShortlisted = hasLocalState ? Boolean((_localShortlists1 = localShortlists) === null || _localShortlists1 === void 0 ? void 0 : (_localShortlists_localShortlistedItems1 = _localShortlists1.localShortlistedItems) === null || _localShortlists_localShortlistedItems1 === void 0 ? void 0 : (_localShortlists_localShortlistedItems_find = _localShortlists_localShortlistedItems1.find(function(localShortlist) {
        return localShortlist.id === productId;
    })) === null || _localShortlists_localShortlistedItems_find === void 0 ? void 0 : _localShortlists_localShortlistedItems_find.isShortlisted) : initialChecked;
    var _useMutation = _sliced_to_array(useMutation(isShortlisted ? MutationRemoveShortlistItem : MutationSaveShortlistItem, {
        optimisticResponse: isShortlisted ? optimisticRemoveResponse() : optimisticSaveResponse(productId, productType),
        update: function update(cache) {
            var updatedEntry = {
                __typename: "LocalShortlistedItem",
                id: productId,
                productType: productType,
                isShortlisted: !isShortlisted
            };
            var items;
            try {
                var _cachedEntries_localShortlistedItems, _cachedEntries;
                var cachedEntries = cache.readQuery({
                    query: LocalStateQuery
                });
                items = ((_cachedEntries = cachedEntries) === null || _cachedEntries === void 0 ? void 0 : (_cachedEntries_localShortlistedItems = _cachedEntries.localShortlistedItems) === null || _cachedEntries_localShortlistedItems === void 0 ? void 0 : _cachedEntries_localShortlistedItems.filter(function(entry) {
                    return entry.id !== productId;
                })) || [];
            } catch (e) {
                items = [];
            }
            cache.writeQuery({
                query: LocalStateQuery,
                data: {
                    localShortlistedItems: _to_consumable_array(items).concat([
                        updatedEntry
                    ])
                }
            });
        }
    }), 1), saveOrRemove = _useMutation[0];
    React2.useEffect(function() {
        setId(Math.random().toString(36).substr(2, 5));
    }, [
        setId
    ]);
    return /* @__PURE__ */ React2.createElement(UitkFavoriteSwitch, {
        label: label || "",
        checked: isShortlisted,
        id: "heart-button-".concat(id),
        onChange: function() {
            saveOrRemove({
                variables: variables
            });
            if (onChange && typeof onChange === "function") {
                onChange(isShortlisted, !isShortlisted, toggleDispatch);
            }
        }
    });
};
export { ProductType, ShortlistToggle, ShortlistToggleProvider };
//# sourceMappingURL=index.js.map